const claims = {
  admin: {
    read: 'admin-read',
    write: 'admin-write',
  },
  inspection: {
    read: 'inspection-read',
    write: 'inspection-write',
  },
  journal: {
    read: 'journal-read',
    write: 'journal-write',
  },
  report: {
    read: 'report-read',
  },
  workorder: {
    read: 'workorder-read',
    write: 'workorder-write',
  },
  safetyCase: {
    read: 'safetycase-read',
    write: 'safetycase-write',
  },
  hero: {
    read: 'hero-read',
    write: 'hero-write',
  },
  training: {
    read: 'training-read',
    write: 'training-write',
  },
}

export default claims
